import { Card } from "uikit/components";
import styles from "./FederationEventsView.module.styl";
import { arrayOf, number, shape, string } from "prop-types";
import React from "react";
import FederationEventsRow from "components/federationSummary/FederationEventsRow/FederationEventsRow";

export default function FederationEventsView({ federationEvents }) {
    return (
        <Card borderRadius={"giant"} padding={"none"} className={styles.form}>
            <div className={styles.headingContainer} data-test-name="federation_events_form">
                <div className={styles.federationEventName}>Название мероприятия</div>
                <div className={styles.eventSportType}>Вид спорта</div>
                <div className={styles.eventType}>Вид мероприятия</div>
                <div className={styles.eventStatus}>Статус мероприятия</div>
                <div className={styles.location}>Место проведения</div>
                <div className={styles.eventStartDate}>Дата начала</div>
                <div className={styles.eventEndDate}>Дата завершения</div>
            </div>
            <div>
                {federationEvents.map((item) => (
                    <FederationEventsRow key={item.federationEventId} regionEvent={item} />
                )) ?? []}
            </div>
        </Card>
    );
}

FederationEventsView.propTypes = {
    federationEvents: arrayOf(
        shape({
            federationEventId: number,
            federationEventName: string,
            eventSportType: string,
            eventType: string,
            eventStatus: string,
            locationAddress: string,
            locationShortName: string,
            location: string,
            eventStartDate: string,
        }),
    ),
};
